import React, { useState, useEffect } from "react";
import { formatDateTime, isoToSqlDate } from "../../../helpers/helpers";
// import peij from "../../../services/peij";
import modalidadeAssinatura from "../../../enums/modalidadeAssinatura";
import Form from "../../../components/form";
import { CircularProgress } from "@mui/material";
import MUIDataTable from "mui-datatables";
import ijws from "../../../services/ijws";

let dataAtual = new Date();
let dataAnterior = new Date();
dataAnterior.setMonth(dataAnterior.getMonth() - 1);

const Assinaturas = ({ match, history }) => {
  const [carregando, setCarregando] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [filtros, setFiltros] = useState({
    dataInicio: isoToSqlDate(dataAnterior.toISOString()),
    dataFim: isoToSqlDate(dataAtual.toISOString()),
  });
  const [totais, setTotais] = useState({
    preCadastros: 0,
    cadastros: 0,
    assinaturas: 0,
    percCadastros: 0,
    percAssinaturas: 0,
  });

  useEffect(() => {
    carregarRelatorio();
  }, []);

  const carregarRelatorio = (filtrosAtuais = filtros) => {
    setCarregando(true);
    setFiltros(filtrosAtuais);

    ijws
      .get("admin/relatorios/assinaturas", filtrosAtuais)
      .then((registros) => {
        console.log("🚀 ~ .then ~ registros:", registros);
        const qtdCadastros = registros.length;
        const qtdAssinaturas = registros.filter((r) => r.dataAssinatura).length;

        let totalDiasAssinaturasAtivas = 0;
        let totalDiasAssinaturasCanceladas = 0;

        registros.forEach((r) => {
          r.dataCadastro = formatDateTime(r.dataCadastro, "D/M/Y h:m");
          r.preCadastroDataHora = r.preCadastroDataHora
            ? formatDateTime(r.preCadastroDataHora, "D/M/Y h:m")
            : "(não realizada)";
          r.dataAssinatura = r.dataAssinatura
            ? formatDateTime(r.dataAssinatura, "D/M/Y h:m")
            : "";
          r.ultimoAcesso = r.ultimoAcesso
            ? formatDateTime(r.ultimoAcesso, "D/M/Y h:m")
            : "-";
          r.modalidadeAssinatura = modalidadeAssinatura.desc(
            r.modalidadeAssinatura
          );

          if (r.assinaturaAtiva === 1) r.situacaoAssinatura = "Ativa";
          if (r.assinaturaCancelamento) r.situacaoAssinatura = "Cancelada";
          if (r.assinaturaSuspensa) r.situacaoAssinatura = "Suspensa";
          if (
            !r.assinaturaAtiva &&
            !r.assinaturaCancelamento &&
            !r.assinaturaSuspensa
          )
            r.situacaoAssinatura = "Vencida";
        });

        const totaisAtualizados = {
          cadastros: qtdCadastros,
          assinaturas: qtdAssinaturas,
          percAssinaturas: ((qtdAssinaturas / qtdCadastros) * 100).toFixed(0),
        };

        setRegistros(registros);
        setTotais(totaisAtualizados);
        setCarregando(false);
      });
  };

  const filtrosForm = (filtros) => {
    return {
      dataInicio: {
        label: "Assinou a partir de ",
        type: "date",
        space: 6,
        value: filtros.dataInicio,
      },
      dataFim: {
        label: "Assinou até",
        type: "date",
        space: 6,
        value: filtros.dataFim,
      },
    };
  };

  const formTotais = (totais) => {
    return {
      cadastros: {
        label: "Cadastros",
        type: "text",
        space: 6,
        value: totais.cadastros,
        readonly: true,
      },
      assinaturas: {
        label: "Assinaturas",
        type: "text",
        space: 6,
        value: `${totais.assinaturas} (${totais.percAssinaturas} %)`,
        readonly: true,
      },
    };
  };

  const columns = [
    {
      name: "usuarioNome",
      label: "Nome",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "usuarioEmail",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "usuarioTelefone",
      label: "Telefone",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "dataCadastro",
      label: "Cadastro",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "preCadastroDataHora",
      label: "Pré-cadastro (aula experimental)",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "dataAssinatura",
      label: "Assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "situacaoAssinatura",
      label: "Situação da assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "modalidadeAssinatura",
      label: "Modalidade da assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    rowsPerPage: 50,
    downloadOptions: {
      filename: "assinaturas_ij.csv",
      separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  const fFiltros = {
    title: "Filtros",
    form: filtrosForm(filtros),
    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },
  };

  const fTotais = {
    title: "Totais",
    form: formTotais(totais),
  };

  return (
    <div>
      <Form formData={fFiltros} />
      <Form formData={fTotais} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <MUIDataTable
          title="Inglês Juntos - Assinaturas"
          data={registros}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
};

export default Assinaturas;
